import React from 'react';
import './Poll.scss';
import Globals from "../../api";
import ads5 from '../../assets/img/ads5.png';
import MustRead from '../../components/MustRead/Mustread';
import OpinionWidget from '../../components/opinionwidget/Opinionwidget';

export default class PollPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           data : [],
           PollItems :[]
          
         };
      }
    componentDidMount() {
        // console.log('api at header' + Globals.language_based_api);
        //let url = window.location.pathname;
        const PollListURL = Globals.language_based_api + "/poll/list";
            fetch(PollListURL)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  data : data.Contents[2],
                  PollItems : data.Contents[2].Items
                })
            }) 
       
          }
    render() {
        //console.log("poll data ", this.state.data)
        let PollData = this.state.data;
        let PollItems = this.state.PollItems;
        let ActivePollListData = PollItems.filter((x) => x.IsArchive == 0);
        let InactivePollListData = PollItems.filter((x) => x.IsArchive == 1);
        const _ActivePollDataItemss = ActivePollListData.map((item, count) =>{
        const name = item.Question;
        return(
            <>
           
            </>
                // <div className="question_an_sect" key={count}>
                //     <div className="quest_a_head">{item.Question}</div>
                //         <div className="quest_a_body">
                            
                //         {
                //         // (() => {if(item.Options != null){
                //         item.Options.map((item, i) => {
                //         console.log("item",item.GroupID)
                       
                        
                //         return(
                //                    <div className="q_a_radio" key={i}>
                //                    <span className="q_a_result">
                //                        <span className="q_a_progress"  style={{width : item.Percentage +"%"}}></span>
                //                        <span className="q_a_prog_count">{item.Percentage}%</span>
                //                    </span>
                //                    <span className="q_a_radio_click">
                //                        <input type="radio" id={"radio"+i} name={(item.GroupID)? item.GroupID : ""}/>
                //                        <label htmlFor={"radio"+i}>{item.Option}</label>
                //                    </span> 
                //                </div>

                //         )})}
                //         {/* })()}                 */}
                //             <button className="btn btn-block btn-outline-primary">भाग लीजिए</button>
                //             </div>
                //             </div>
        )})

        const _InactivePollDataItemss = InactivePollListData.map((item, count) => (
                <li key={count}>
                <div className="polls_block_w">
                    <h3 className="poll_que">{item.Question}</h3>
                    <div className="polls_result_b">
                    {item.Options.map((item, i) => (
                            <div className="poll_q_row">
                            <div className="poll_que_col">{item.Option}</div>
                            <div className="poll_anw_col">
                                <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : item.Percentage+"%", 'backgroundColor': item.Color}}>
                                </span><span className="poll_per_c">{item.Percentage}</span></div>
                            </div>
                        </div>
                    ))}
                 </div>
                </div>
                </li>
        ))

        
        const percent_1 = {
            color: 'white',
            backgroundColor: 'red',
            fontSize: 200,
            width: '200px'
        };
        return (
            <div>

                <div className="container padding15">
                    <div className="row">
                        <div className="col">

                            <div className="poll_page">
                                <h1 className="poll_title">Poll</h1>
                                <h4 className="poll_sub_title">{PollData.CurrentSurveyText}</h4>
                                <div className="current_poll_b">
                                <OpinionWidget dataFromParent={ActivePollListData}/>
                    {_ActivePollDataItemss}
                
           
                                  
                                </div>
                                <h4 className="poll_sub_title">{PollData.PreviousSurveyText}</h4>

                                <ul className="polls_listing">
                                    {_InactivePollDataItemss}
                                    {/* <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>

                                        <div className="polls_block_w">
                                            <h3 className="poll_que">कोरोना के बढ़ते संक्रमण के मद्देनजर क्या इस बार होली घर में ही मनानी चाहिए?</h3>
                                            <div className="polls_result_b">
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">हां</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "63%", 'backgroundColor': '#5DA5DA',}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "50%", 'backgroundColor': '#FAA43A'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                                <div className="poll_q_row">
                                                    <div className="poll_que_col">पता नहीं</div>
                                                    <div className="poll_anw_col">
                                                        <div className="poll_progress"><span className="poll_progr_bar" style={{"width" : "10%", 'backgroundColor': '#F17CB0'}}></span><span className="poll_per_c">63.12%</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </li> */}
                                </ul>


                            </div>







                        </div>
                        <div className="col right_side_bar">
                            <div className="ads_block m-b-15"><img src={ads5} /></div>
                            {/* <MustRead /> */}
                            <div className="m-b-15"></div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}